<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="92" height="100" viewBox="0 0 92 100" fill="none">
    <path d="M92 99H1L1 2.26498e-06" stroke="#000711" />
  </svg>
</template>
